import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getUserUsedLimits} from 'src/openapi/admin/apis/GetUserUsedLimitsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
};

export const useUsedLimits = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getUserUsedLimits({userId}, {signal}),
    ), [userId, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
